class KCVS.Select2CollectionInput
  constructor: (input) ->
    @input = $(input)
    @options = @input.data('options')
    @options ||= {}

    unless @options.hasOwnProperty 'allowClear'
      @options.allowClear = true

    @input.select2(@selectOptions())

  selectOptions: ->
    opts =
      allowClear: @options.allowClear
      dropdownAutoWidth: @input.data('dropdown-auto-width')
      dropdownCssClass: @input.data('dropdown-css-class')
      formatNoMatches: _.bind(@formatNoMatches, @)
      theme: 'bootstrap'
      tags: @options.tags || false
      tokenSeparators: @options.separators
      placeholder: ""
    if @options.allowCreate
      opts.createTag = (term, choices) ->
        unless _.any(choices, (choice) -> choice.text is term)
          { id: term, text: term }

    opts

  formatNoMatches: ->
    I18n.t("select2.messages.no_matches")

$ ->
  $('.select2_collection select').each ->
    new KCVS.Select2CollectionInput(this)
